// extracted by mini-css-extract-plugin
export var content = "newsletter-module--content--64237";
export var cta = "newsletter-module--cta--bca83";
export var heart = "newsletter-module--heart--84f1b";
export var icon = "newsletter-module--icon--fe184";
export var inner = "newsletter-module--inner--72553";
export var newsletter = "newsletter-module--newsletter--34854";
export var text = "newsletter-module--text--97102";
export var title = "newsletter-module--title--0a2cf";